import _ from 'lodash'
import { request } from '../utils/sockets'
import config from '../config/custom'

export const REQUEST_DISPATCHES = 'dispatches/REQUEST_DISPATCHES'
export const GET_DISPATCHES = 'dispatches/GET_DISPATCHES'
export const REQUEST_FAILED = 'dispatches/REQUEST_FAILED'
export const SET_DISPATCH = 'dispatches/SET_DISPATCH'
export const ADD_DISPATCH = 'dispatches/ADD_DISPATCH'
export const UPDATE_DISPATCH = 'dispatches/UPDATE_DISPATCH'
export const REMOVE_DISPATCH = 'dispatches/REMOVE_DISPATCH'
export const SET_PAGINATION = 'dispatches/SET_PAGINATION'

let initialState = {
    fetching: false,
    items: [],
    selected: null,
    options: {},
    total: 0,
    record: null,
    pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_DISPATCHES:
            return {
                ...state,
                fetching: true
            }

        case GET_DISPATCHES:
            return {
                ...state,
                items: action.items,
                total: action.pagination && action.pagination.total,
                pagination: action.pagination,
                fetching: false
            }

        case REQUEST_FAILED:
            return {
                ...state,
                fetching: false
            }

        case SET_DISPATCH:
            return {
                ...state,
                selected: action.id,
                record: action.record
            }

        case SET_PAGINATION:
            return {
                ...state,
                pagination: action.pagination
            }

        case ADD_DISPATCH:
            return {
                ...state,
                items: [action.item, ...state.items]
            }

        case UPDATE_DISPATCH:
            let items = [...state.items]
            const index = _.findIndex(items, { id: action.item.id })

            if (index !== -1) {
                items.splice(index, 1, { ...items[index], ...action.item })
            }

            return { ...state, items }

        case REMOVE_DISPATCH:
            let _items = [...state.items]
            const _index = _.findIndex(_items, { id: action.id })

            if (_index !== -1) {
                _items.splice(_index, 1)
            }

            return { ...state, _items }

        default:
            return state
    }
}


export const getDispatches = () => (dispatch, getState) => {
        
    const state = getState();
    const { pagination } = state.dispatch;

    dispatch({
        type: REQUEST_DISPATCHES
    })
    request(`${config.baseUrl}/dispatch/search`, {
            params: {
                ...state.search,
                page: pagination.page,
                pageSize: pagination.pageSize
            },
    })
        .then(response => {
            dispatch({
                type: GET_DISPATCHES,
                items: response.dispatches,
                total: response.pagination.total,
                pagination: response.pagination
            })
        })
        .catch(error => {
            dispatch({
                type: REQUEST_FAILED
            })
        })
}

export const setPagination = (page, pageSize) => (dispatch) => {
    dispatch({
        type: SET_PAGINATION,
        pagination: {
            page,
            pageSize
        }
    })
    return dispatch(getDispatches())
}

export const getDispach = (id) => {
    return (dispatch, getState) => {
        request(`${config.baseUrl}/dispatch/${id}`)
            .then(response => {
                dispatch({
                    type: SET_DISPATCH,
                    id: id,
                    record: response.data
                })
            })
            .catch(error => {
                dispatch({
                    type: REQUEST_FAILED
                })
            })
    }
}

export const setDispatch = (id, record) => {
    return dispatch => {
        dispatch({
            type: SET_DISPATCH,
            id,
            record
        })
    }
}

export const addDispatch = (data) => {
    return (dispatch, getState) => {
        const state = getState()

        if (_.findIndex(state.items, { id: data.id }) === -1) {
            dispatch({
                type: ADD_DISPATCH,
                item: data
            })
        }
    }
}

export const updateDispatch = (data) => {
    return dispatch => {
        dispatch({
            type: UPDATE_DISPATCH,
            item: data
        })
    }
}

export const updateDispatchById = (id) => {
    console.log(`${config.baseUrl}/dispatch/${id}`)
    return dispatch => {
        request(`${config.baseUrl}/dispatch/${id}`)
            .then(response => {
                dispatch({
                    type: UPDATE_DISPATCH,
                    item: response
                })
            })
            .catch(() => {
                // 
            })
    }
}

export const removeDispatch = (id) => {
    return dispatch => {
        dispatch({
            type: REMOVE_DISPATCH,
            id
        })
    }
}



// WEBPACK FOOTER //
// ./src/modules/dispatch.js